import { render, staticRenderFns } from "./fdInventory42.vue?vue&type=template&id=b3cb813c"
import script from "./fdInventory42.vue?vue&type=script&lang=js"
export * from "./fdInventory42.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports